import { render, staticRenderFns } from "./AdminPinboard.vue?vue&type=template&id=0348f958&scoped=true&"
import script from "./AdminPinboard.vue?vue&type=script&lang=ts&"
export * from "./AdminPinboard.vue?vue&type=script&lang=ts&"
import style0 from "./AdminPinboard.vue?vue&type=style&index=0&id=0348f958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0348f958",
  null
  
)

export default component.exports